import _ from 'lodash';
import React from 'react';

import { useLocation } from 'react-router';

import { MENUS, REGISSEUR } from '@/constants';
import { RegieContext } from '@/contexts';
import { useRegieStore, useRegisseurStore } from '@/zustand';
import AccessForbiden from '../Autre/AccessForbiden';

/**
 * Composant dédié à la gestion des accès du régisseur connecté aux différents points de menu
 * sur la régie sélectionnée
 *
 */
const RegisseurRouter = (props) => {
  const { children } = props;

  const [accessForbidden, setAccessForbidden] = React.useState(null);

  const { showList, regies } = React.useContext(RegieContext);

  const connectedRegisseur = useRegisseurStore((state) => state.regisseur);
  const { mandat } = connectedRegisseur || {};

  const hasRegies = useRegieStore((state) => state.hasRegies);

  const location = useLocation();

  React.useEffect(() => {
    // S'il y a un régisseur et qu'il a des régies on controle, sinon on laisse passer
    // Les controles sont fait en amont
    if (!_.isNil(mandat) && hasRegies) {
      // On supprime /administres/regie et /finances/regie et /facturation/regie de l'url
      // pour ne garder que la partie vraiment métier
      let locationRoot = _.replace(location.pathname, '/administres/regie', '');
      locationRoot = _.replace(locationRoot, '/finances/regie', '');
      locationRoot = _.replace(locationRoot, '/facturation/regie', '');

      if (locationRoot === '') {
        // On est sur l'accueil
        locationRoot = '/';
      }

      // On récupère que le premier élément dans l'url
      locationRoot = `/${locationRoot.split('/')[1]}`;

      const menuLocation = _.findKey(MENUS.LOCATIONS, (menu) => menu === locationRoot);

      if (mandat === REGISSEUR.TYPE_PRINCIPAL) {
        setAccessForbidden(!_.includes(MENUS.DROITS_REGISSEUR, menuLocation));
      } else if (mandat === REGISSEUR.TYPE_SUPPLEANT) {
        setAccessForbidden(!_.includes(MENUS.DROITS_REGISSEUR_SUPPLEANT, menuLocation));
      } else {
        setAccessForbidden(!_.includes(MENUS.DROITS_AGENT_GUICHET, menuLocation));
      }
    }
  }, [hasRegies, location, mandat]);

  if (accessForbidden) {
    return <AccessForbiden {...(_.size(regies) > 1 && { onRegiesShow: showList })} />;
  }

  return children;
};

export default RegisseurRouter;
